import(/* webpackMode: "eager" */ "D:\\a\\_work\\1\\s\\src\\app\\error.tsx");
